import { PrimaryActionButtonController } from './primary_action_button/primary_action_button.controller';
import { ToolbarController } from './toolbar/toolbar.controller';
import { NavBarController } from './navbar/navbar.controller';
import { PrimaryActionButton } from './primary_action_button/primary_action_button.directive';
import { PrimaryAction } from './primary_action_button/primary_action_button.service';
import { Toolbar } from './toolbar/toolbar.directive';


export const initialise = () => {

  /**
   * A module against which the major layout component are registered such as the sidebar for navigation and the top toolbar
   */
  angular.module('app.layout', ['ngMaterial', 'actora.services'])
    .controller('NavbarController', <any>NavBarController)
    .controller('ToolbarController', <any>ToolbarController)
    .controller('primaryActionButtonController', <any>PrimaryActionButtonController)
    .directive('primaryActionButton', () => { return new PrimaryActionButton(); })
    .directive('actToolbar', () => { return new Toolbar(); })
    .factory('PrimaryAction', () => { return new PrimaryAction(); });
};